
riot.tag2('tags', '  <div class="tags-item" each="{item, i in items}" if="{item !== null}">\n    <div class="tags-item-body"><span class="title" title="{item.name}">{item.name}</span><span class="close" onclick="{remove}">&times;</span></div>\n  </div>\n', 'tags,[riot-tag="tags"],[data-is="tags"]{ height: auto !important; padding-bottom: 0 !important; padding-left: 6px !important; min-height: 40px; } tags .tags-item,[riot-tag="tags"] .tags-item,[data-is="tags"] .tags-item{ display: inline-block; max-width: 250px; color: #333; background-color: #fff; border-radius: 4px; padding: 2px 4px; margin-right: 4px; margin-bottom: 6px; border: 1px solid #ccc; } tags .tags-item:hover,[riot-tag="tags"] .tags-item:hover,[data-is="tags"] .tags-item:hover{ border: 1px solid #aaa; } tags .tags-item-body,[riot-tag="tags"] .tags-item-body,[data-is="tags"] .tags-item-body{ display: block; position: relative; } tags .tags-item-body .title,[riot-tag="tags"] .tags-item-body .title,[data-is="tags"] .tags-item-body .title{ display: inline-block; overflow: hidden; text-overflow: ellipsis; vertical-align: top; max-width: 225px; white-space: nowrap; cursor: default; } tags .tags-item-body .close,[riot-tag="tags"] .tags-item-body .close,[data-is="tags"] .tags-item-body .close{ line-height: 0.85; }', '', function(opts) {
    var self = this

    self.items = []

    Object.defineProperty(self.root, 'value', {
        get: function () {
            return self.items
        },
        set: function (value) {
            self.items = value
        }
    })

    self.remove = function () {
        self.items.splice(this.i, 1)
    }

    self.add = function (item) {
        for (var i = 0; i < self.items.length; i++)
            if (self.items[i].id)
                if (self.items[i].id == item.id) return

        if (self.items instanceof Array) {
            self.items.push(item)
        } else {
            self.items = []
            self.items.push(item)
        }
    }

    var sortableOption = {
        onEnd: function (evt) {
            self.items.splice(evt.newIndex, 0, self.items.splice(evt.oldIndex, 1)[0])
            var temp = self.items
            self.items = []
            self.update()
            self.items = temp
            self.update()
        }
    }

    self.on('mount', function () {
        //Sortable.create(self.root, sortableOption)
    })
});


// WEBPACK FOOTER //
// ./components/tags.tag